import { doc, getDoc } from 'firebase/firestore'
import {
  stripeCheckoutProjectionSchema,
  type ConsultationId,
  type ConsultationProjectionKey,
  type StripeCheckoutProjection,
} from '@gh/common/models'
import { firestore } from '@/firebase'
import createLogger from '@/utils/logger'

const logger = createLogger('stripe/clinicalStripeCheckoutProjection')

export function isStripeCheckoutProjectionPaid(
  projection: StripeCheckoutProjection | null | undefined,
): boolean {
  if (!projection) {
    return false
  }
  return projection.paid === true || projection.status === 'paid'
}

export async function readConsultationStripeCheckoutProjection(args: {
  consultationId: ConsultationId
  projectionKey: ConsultationProjectionKey
}): Promise<StripeCheckoutProjection | null> {
  const snapshot = await getDoc(
    doc(firestore, 'consultations', args.consultationId, 'projections', args.projectionKey),
  )
  if (!snapshot.exists()) {
    return null
  }
  const parsed = stripeCheckoutProjectionSchema.safeParse({
    id: snapshot.id,
    ...snapshot.data(),
  })
  if (!parsed.success) {
    logger.error('Failed to parse consultation stripe checkout projection', {
      consultationId: args.consultationId,
      projectionKey: args.projectionKey,
      error: parsed.error,
    })
    return null
  }
  return parsed.data
}
